import { render, staticRenderFns } from "./Poros.vue?vue&type=template&id=ca05b2a8"
import script from "./Poros.vue?vue&type=script&lang=js"
export * from "./Poros.vue?vue&type=script&lang=js"
import style0 from "./Poros.vue?vue&type=style&index=0&id=ca05b2a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports